import { useAppState } from "../../context/appStateContext"
import useQueryParams from "../../hooks/useQueryParams"
import { isBanner } from "../../utils/utils"
import styles from "./SafeAreaInsetPage.module.scss"

const SafeAreaInsetPage = (props: React.PropsWithChildren) => {
  const {
    initialData,
    footerInsetColor,
    headerInsetColor,
    ignoreFooterInset,
    ignoreHeaderInset,
  } = useAppState().state

  let paddingTop = initialData?.topInset ?? 0
  let paddingBottom = initialData?.bottomInset ?? 0
  let totalPadding = paddingBottom + paddingTop

  if (isBanner()) {
    paddingTop = 0
    paddingBottom = 0
    totalPadding = 0
  }

  if (ignoreFooterInset) {
    totalPadding -= paddingBottom
    paddingBottom = 0
  }

  if (ignoreHeaderInset) {
    totalPadding -= paddingTop
    paddingTop = 0
  }

  return (
    <div
      className={styles.container}
      style={{
        paddingTop,
        paddingBottom,
        height: `calc(100vh - ${totalPadding}px)`,
      }}
    >
      {props.children}
      {!ignoreHeaderInset && (
        <div
          className={styles.insetHeader}
          style={{
            backgroundColor: headerInsetColor,
            height: paddingTop,
            zIndex: 3,
          }}
        ></div>
      )}
      {!ignoreFooterInset && (
        <div
          className={styles.insetFooter}
          style={{
            backgroundColor: footerInsetColor,
            height: paddingBottom,
            zIndex: 3,
          }}
        ></div>
      )}
    </div>
  )
}

export default SafeAreaInsetPage
